// import React, { useState, useEffect } from 'react'
// import { Button, Col, Container, Form, Modal, Row } from 'react-bootstrap'
// import { useNavigate, useParams } from 'react-router-dom'
// import axios from 'axios'
// import Cookies from 'js-cookie'
// import toast from 'react-hot-toast'

// const Updateassociate = () => {
//   const { updateassociateid } = useParams() // Get broker ID from URL
//   const [brokerData, setBrokerData] = useState({
//     name: '',
//     father_name: '',
//     email: '',
//     phone_number: '',
//     pancard_number: '',
//     id_number: '',
//     address: '',
//     id_type: 'SELECT',
//     broker_level: 'SELECT',
//     refer_by: '',
//     account_holder_name: '',
//     account_number: '',
//     bank_name: '',
//     ifsc_code: '',
//   })
//   const [brokers, setBrokers] = useState([])

//   const [showModal, setShowModal] = useState(false) // State for modal
//   const validIdTypes = ['AADHAR CARD', 'PAN CARD', 'LICENSE']
//   const validLevels = [
//     'LEVEL1',
//     'LEVEL2',
//     'LEVEL3',
//     'LEVEL4',
//     'LEVEL5',
//     'LEVEL6',
//     'LEVEL7',
//     'LEVEL8',
//     'LEVEL9',
//     'LEVEL10',
//     'LEVEL11',
//     'LEVEL12',
//     'LEVEL13',
//   ]
//   const [error, setError] = useState('')
//   const [loading, setLoading] = useState(false)
//   const navigate = useNavigate()

//   const token = Cookies.get('authToken')

//   const axiosInstance = axios.create({
//     baseURL: BASE_URL,
//     headers: {
//       'Content-Type': 'application/json',
//       Authorization: `Bearer ${token}`,
//     },
//   })

//   useEffect(() => {
//     const fetchBrokers = async () => {
//       try {
//         const response = await axiosInstance.get(
//           BASE_URL+'/brokers/search',
//         )
//         setBrokers(response.data.data)
//         console.log('Brokers fetched:', response.data.data)
//       } catch (error) {
//         toast.error('Failed to fetch brokers')
//       }
//     }
//     fetchBrokers()
//   }, [])

//   // Handle form input changes
//   const inputHandler = (e) => {
//     const { name, value } = e.target
//     setBrokerData({ ...brokerData, [name]: value })
//     console.log(`Updated ${name}:`, value)
//   }
//   useEffect(() => {
//     const fetchBrokerData = async () => {
//       if (!token) {
//         setError('Authentication required. Please log in.')
//         return
//       }
//       setLoading(true)
//       try {
//         const response = await axios.get(
//           BASE_URL+`/broker/${updateassociateid}`,
//           {
//             headers: {
//               'Content-Type': 'application/json',
//               Authorization: `Bearer ${token}`,
//             },
//           },
//         )
//         const data = response.data.data
//         setBrokerData({
//           ...data,
//           refer_by: data.refer_by || '',
//         })
//         console.log('Broker data fetched:', data)
//       } catch (err) {
//         setError('Failed to fetch broker data.')
//       } finally {
//         setLoading(false)
//       }
//     }
//     fetchBrokerData()
//   }, [updateassociateid, token])

//   const handleBrokerSelect = (e) => {
//     const selectedBrokerId = parseInt(e.target.value, 10)
//     setBrokerData((prevData) => ({ ...prevData, refer_by: selectedBrokerId }))
//     console.log('Selected refer_by:', selectedBrokerId)
//   }

//   const handleModalClose = () => {
//     setShowModal(false)
//   }

//   // Handle form submission for updating broker
//   const handleSubmit = async (e) => {
//     e.preventDefault()
//     setLoading(true)
//     if (!token) {
//       setError('Authentication required. Please log in.')
//       return
//     }

//     if (!validIdTypes.includes(brokerData.id_type)) {
//       toast.error('Invalid id type selected')
//       return
//     }

//     if (!validLevels.includes(brokerData.broker_level)) {
//       toast.error('Invalid associate level selected')
//       return
//     }

//     // Payload including the broker ID and name
//     const payload = {
//       ...brokerData, // Your updated broker data (including name)
//       id: updateassociateid, // Pass the broker ID as part of the data
//     }

//     console.log('Payload being sent:', payload)
//     try {
//       const response = await axios.post(
//         BASE_URL+'/broker/update',
//         payload,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       )
//       console.log('Broker updated successfully:', response.data)
//       setShowModal(true)
//       setTimeout(() => {
//         navigate('/allassociate')
//         window.location.reload()
//       }, 3000)
//     } catch (err) {
//       console.error('Error updating broker:', err)
//       setError('Failed to update broker.')
//     } finally {
//       setLoading(false)
//     }
//   }

//   return (
//     <Container
//       style={{ maxWidth: '1100px', marginRight: '13rem' }}
//       className="mt-0 p-0"
//     >
//       <Form className="text-start m-0 p-0" onSubmit={handleSubmit}>
//         <h1
//           className="display-6 text-success bg-light fw-bold text-center p-1"
//           style={{ borderBottom: '1px solid gray' }}
//         >
//           Update Associate
//         </h1>

//         <Row>
//           <Col md={6} className="mb-3">
//             <Form.Label htmlFor="name">Name</Form.Label>
//             <Form.Control
//               type="text"
//               id="name"
//               name="name"
//               value={brokerData.name}
//               onChange={inputHandler}
//             />
//           </Col>

//           <Col md={6} className="mb-3">
//             <Form.Label htmlFor="father_name">Father Name</Form.Label>
//             <Form.Control
//               type="text"
//               id="father_name"
//               name="father_name"
//               value={brokerData.father_name}
//               onChange={inputHandler}
//             />
//           </Col>
//         </Row>

//         <Row>
//           <Col md={6} className="mb-3">
//             <Form.Label htmlFor="email">Email</Form.Label>
//             <Form.Control
//               type="email"
//               id="email"
//               name="email"
//               value={brokerData.email}
//               onChange={inputHandler}
//             />
//           </Col>
//           <Col md={6} className="mb-3">
//             <Form.Label htmlFor="phone_number">Phone Number</Form.Label>
//             <Form.Control
//               type="tel"
//               id="phone_number"
//               name="phone_number"
//               value={brokerData.phone_number}
//               placeholder={brokerData.phone_number || 'Enter phone number'}
//               onChange={inputHandler}
//             />
//           </Col>
//         </Row>
//         <Row>
//           <Col md={12} className="mb-3">
//             <Form.Label htmlFor="address">Address</Form.Label>
//             <Form.Control
//               as="textarea"
//               id="address"
//               name="address"
//               value={brokerData.address}
//               onChange={inputHandler}
//             />
//           </Col>
//         </Row>
//         <Row>
//           <Col md={6} className="mb-3">
//             <Form.Label htmlFor="account_holder_name">
//               Account Holder Name
//             </Form.Label>
//             <Form.Control
//               type="text"
//               id="account_holder_name"
//               name="account_holder_name"
//               value={brokerData.account_holder_name}
//               onChange={inputHandler}
//             />
//           </Col>

//           <Col md={6} className="mb-3">
//             <Form.Label htmlFor="account_number">Account Number</Form.Label>
//             <Form.Control
//               type="text"
//               id="account_number"
//               name="account_number"
//               value={brokerData.account_number}
//               onChange={inputHandler}
//             />
//           </Col>
//         </Row>
//         <Row>
//           <Col md={6} className="mb-3">
//             <Form.Label htmlFor="bank_name">Bank Name</Form.Label>
//             <Form.Control
//               type="text"
//               id="bank_name"
//               name="bank_name"
//               value={brokerData.bank_name}
//               onChange={inputHandler}
//             />
//           </Col>

//           <Col md={6} className="mb-3">
//             <Form.Label htmlFor="ifsc_code">IFSC Code</Form.Label>
//             <Form.Control
//               type="text"
//               id="ifsc_code"
//               name="ifsc_code"
//               value={brokerData.ifsc_code}
//               onChange={inputHandler}
//             />
//           </Col>
//         </Row>

//         <Row>
//           <Col md={6} className="mb-3">
//             <Form.Label htmlFor="id_type">ID Type</Form.Label>
//             <Form.Select
//               id="id_type"
//               name="id_type"
//               value={brokerData.id_type}
//               onChange={inputHandler}
//             >
//               <option>SELECT</option>
//               <option value="AADHAR CARD">AADHAR CARD</option>
//               <option value="PAN CARD">PAN CARD</option>
//               <option value="LICENSE">DRIVING LICENSE</option>
//             </Form.Select>
//           </Col>

//           <Col md={6} className="mb-3">
//             <Form.Label htmlFor="id_number">Id Number</Form.Label>
//             <Form.Control
//               type="text"
//               id="id_number"
//               name="id_number"
//               value={brokerData.id_number}
//               onChange={inputHandler}
//             />
//           </Col>
//         </Row>
//         <Row>
//           <Col md={6} className="mb-3">
//             <Form.Label htmlFor="broker_level">Associate's Level</Form.Label>
//             <Form.Select
//               id="broker_level"
//               name="broker_level"
//               value={brokerData.broker_level}
//               onChange={inputHandler}
//             >
//               <option>SELECT</option>
//               <option value="LEVEL1">LEVEL 1 - 4%</option>
//               <option value="LEVEL2">LEVEL 2 - 5%</option>
//               <option value="LEVEL3">LEVEL 3 - 6%</option>
//               <option value="LEVEL4">LEVEL 4 - 7%</option>
//               <option value="LEVEL5">LEVEL 5 - 8%</option>
//               <option value="LEVEL6">LEVEL 6 - 9%</option>
//               <option value="LEVEL7">LEVEL 7 - 10%</option>
//               <option value="LEVEL8">LEVEL 8 - 11%</option>
//               <option value="LEVEL9">LEVEL 9 - 12%</option>
//               <option value="LEVEL10">LEVEL 10 - 13%</option>
//               <option value="LEVEL11">LEVEL 11 - 14%</option>
//               <option value="LEVEL12">LEVEL 12 - 15%</option>
//               <option value="LEVEL13">LEVEL 13 - 18%</option>
//             </Form.Select>
//           </Col>

//           <Col md={6} className="mb-3">
//             <Form.Label htmlFor="pancard_number">Pan Card Number</Form.Label>
//             <Form.Control
//               type="text"
//               id="pancard_number"
//               name="pancard_number"
//               value={brokerData.pancard_number}
//               onChange={inputHandler}
//             />
//           </Col>
//         </Row>
//         <Row>
//           <Col md={6} className="mb-3">
//             <Form.Label htmlFor="refer_by">Refer By</Form.Label>
//             <Form.Select
//               id="refer_by"
//               name="refer_by"
//               value={brokerData.refer_by}
//               onChange={handleBrokerSelect}
//             >
//               <option value="">SELECT</option>
//               {brokers.map((broker) => (
//                 <option key={broker.broker_id} value={broker.broker_id}>
//                   {broker.broker_id}_{broker.name}
//                 </option>
//               ))}
//             </Form.Select>
//           </Col>
//         </Row>
//         {error && <div className="alert alert-danger">{error}</div>}
//         <div className="d-grid mt-4 ">
//           <Button
//             type="submit"
//             className="text-white"
//             style={{ backgroundColor: '#198754', border: 'none' }}
//             disabled={loading}
//           >
//             {loading ? 'Updating...' : 'Update Associate'}
//           </Button>
//         </div>
//       </Form>

//       <Modal show={showModal} onHide={handleModalClose} centered>
//         <Modal.Header closeButton>
//           <Modal.Title className="w-100 text-center">
//             Associate Updated Successfully!
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>
//             You can now view their details or proceed with the next steps in the
//             process.
//           </p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="success" onClick={handleModalClose}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Container>
//   )
// }

// export default Updateassociate
import React, { useState, useEffect } from 'react'
import { Button, Col, Container, Form, Modal, Row } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import Cookies from 'js-cookie'
import toast from 'react-hot-toast'
import {theme} from '../theme/theme'
import { BASE_URL } from '../constants'


const Updateassociate = () => {
  const { updateassociateid } = useParams()
  const navigate = useNavigate()

  const [brokerData, setBrokerData] = useState({
    name: '',
    father_name: '',
    email: '',
    phone_number: '',
    pancard_number: '',
    id_number: '',
    address: '',
    id_type: 'SELECT',
    broker_level: 'SELECT',
    refer_by: '',
    account_holder_name: '',
    account_number: '',
    bank_name: '',
    ifsc_code: '',
  })

  const [brokers, setBrokers] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const validIdTypes = ['AADHAR CARD', 'PAN CARD', 'LICENSE']
  const validLevels = [
    'LEVEL1',
    'LEVEL2',
    'LEVEL3',
    'LEVEL4',
    'LEVEL5',
    'LEVEL6',
    'LEVEL7',
    'LEVEL8',
    'LEVEL9',
    'LEVEL10',
    'LEVEL11',
    'LEVEL12',
    'LEVEL13',
  ]

  const token = Cookies.get('authToken')
  const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })

  useEffect(() => {
    const fetchBrokers = async () => {
      try {
        const response = await axiosInstance.get('/brokers/search')
        setBrokers(response.data.data)
      } catch {
        toast.error('Failed to fetch brokers')
      }
    }
    fetchBrokers()
  }, [])

  const inputHandler = (e) => {
    const { name, value } = e.target
    setBrokerData({ ...brokerData, [name]: value })
  }

  useEffect(() => {
    const fetchBrokerData = async () => {
      if (!token) {
        setError('Authentication required. Please log in.')
        return
      }
      setLoading(true)
      try {
        const response = await axios.get(
          BASE_URL+`/broker/${updateassociateid}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
          }
        )
        const data = response.data.data
        setBrokerData({ ...data, refer_by: data.refer_by || '' })
      } catch {
        setError('Failed to fetch broker data.')
      } finally {
        setLoading(false)
      }
    }
    fetchBrokerData()
  }, [updateassociateid, token])

  const handleBrokerSelect = (e) => {
    setBrokerData((prev) => ({ ...prev, refer_by: e.target.value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    if (!token) {
      setError('Authentication required. Please log in.')
      return
    }

    if (!validIdTypes.includes(brokerData.id_type)) {
      toast.error('Invalid ID type selected')
      return
    }

    if (!validLevels.includes(brokerData.broker_level)) {
      toast.error('Invalid associate level selected')
      return
    }

    const payload = { ...brokerData, id: updateassociateid }

    try {
      await axios.post(
        BASE_URL+'/broker/update',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      )
      setShowModal(true)
      toast.success('Associate updated successfully!')
      setTimeout(() => {
        navigate('/allassociate')
        window.location.reload()
      }, 3000)
    } catch (err) {
      toast.error('Failed to update associate')
      setError('Failed to update associate.')
    } finally {
      setLoading(false)
    }
  }

  return (
   <Container className="pb-3" style={{fontFamily: theme.font.family }}>
      <Form onSubmit={handleSubmit} 
      
        className="mx-auto px-3 rounded-3"
        style={{

          backgroundColor: theme.colors.background,
          
      
        }}   
      >
         <p
           className="mb-4 fw-bold"
           style={{
             color: theme.colors.primary,
             borderBottom: `2px solid ${theme.colors.secondary}`,
             paddingBottom: '8px',
             fontSize: '1.5rem',
           }}
         >
             Update Associate
         </p>


        <Row>
          <Col md={6} className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              value={brokerData.name}
              onChange={inputHandler}
              required
            />
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label>Father Name</Form.Label>
            <Form.Control
              type="text"
              name="father_name"
              value={brokerData.father_name}
              onChange={inputHandler}
            />
          </Col>
        </Row>

        <Row>
          <Col md={6} className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              value={brokerData.email}
              onChange={inputHandler}
            />
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label>Phone Number</Form.Label>
            <Form.Control
              type="tel"
              name="phone_number"
              value={brokerData.phone_number}
              onChange={inputHandler}
            />
          </Col>
        </Row>

        <Form.Group className="mb-3">
          <Form.Label>Address</Form.Label>
          <Form.Control
            as="textarea"
            name="address"
            rows={2}
            value={brokerData.address}
            onChange={inputHandler}
          />
        </Form.Group>

        <Row>
          <Col md={6} className="mb-3">
            <Form.Label>Account Holder Name</Form.Label>
            <Form.Control
              type="text"
              name="account_holder_name"
              value={brokerData.account_holder_name}
              onChange={inputHandler}
            />
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label>Account Number</Form.Label>
            <Form.Control
              type="text"
              name="account_number"
              value={brokerData.account_number}
              onChange={inputHandler}
            />
          </Col>
        </Row>

        <Row>
          <Col md={6} className="mb-3">
            <Form.Label>Bank Name</Form.Label>
            <Form.Control
              type="text"
              name="bank_name"
              value={brokerData.bank_name}
              onChange={inputHandler}
            />
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label>IFSC Code</Form.Label>
            <Form.Control
              type="text"
              name="ifsc_code"
              value={brokerData.ifsc_code}
              onChange={inputHandler}
            />
          </Col>
        </Row>

        <Row>
          <Col md={6} className="mb-3">
            <Form.Label>ID Type</Form.Label>
            <Form.Select
              name="id_type"
              value={brokerData.id_type}
              onChange={inputHandler}
            >
              <option>SELECT</option>
              <option value="AADHAR CARD">AADHAR CARD</option>
              <option value="PAN CARD">PAN CARD</option>
              <option value="LICENSE">DRIVING LICENSE</option>
            </Form.Select>
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label>ID Number</Form.Label>
            <Form.Control
              type="text"
              name="id_number"
              value={brokerData.id_number}
              onChange={inputHandler}
            />
          </Col>
        </Row>

        <Row>
          <Col md={6} className="mb-3">
            <Form.Label>Associate's Level</Form.Label>
            <Form.Select
              name="broker_level"
              value={brokerData.broker_level}
              onChange={inputHandler}
            >
              <option>SELECT</option>
              {validLevels.map((level, i) => (
                <option key={i} value={level}>
                  {level} - {4 + i}%
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col md={6} className="mb-3">
            <Form.Label>PAN Card Number</Form.Label>
            <Form.Control
              type="text"
              name="pancard_number"
              value={brokerData.pancard_number}
              onChange={inputHandler}
            />
          </Col>
        </Row>

        <Row>
          <Col md={6} className="mb-3">
            <Form.Label>Refer By</Form.Label>
            <Form.Select
              name="refer_by"
              value={brokerData.refer_by}
              onChange={handleBrokerSelect}
            >
              <option value="">SELECT</option>
              {brokers.map((b) => (
                <option key={b.broker_id} value={b.broker_id}>
                  {b.broker_id}_{b.name}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>

        {error && (
          <div className="alert alert-danger text-center">{error}</div>
        )}

        <div className="d-grid mt-4">
          <Button
            type="submit"
            disabled={loading}
            style={{
              backgroundColor: theme.colors.primary,
              border: 'none',
              fontWeight: 600,
              letterSpacing: '0.5px',
            }}
          >
            {loading ? 'Updating...' : 'Update Associate'}
          </Button>
        </div>
      </Form>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header
          closeButton
          style={{ backgroundColor: theme.colors.secondary }}
        >
          <Modal.Title className="text-white w-100 text-center">
            Associate Updated Successfully!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          You can now view their details or proceed with the next steps.
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            onClick={() => setShowModal(false)}
            style={{
              backgroundColor: theme.colors.primary,
              border: 'none',
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  )
}

export default Updateassociate
